import { Center, Loader, Text, Stack } from '@mantine/core';

interface LoadingOverlayProps {
  message?: string;
}

export function LoadingOverlay({ message = 'Loading...' }: LoadingOverlayProps) {
  return (
    <Center h="200px">
      <Stack align="center" spacing="sm">
        <Loader size="md" />
        <Text size="sm" color="dimmed">
          {message}
        </Text>
      </Stack>
    </Center>
  );
}

